module.exports = {
    port: 8099, // 项目端口
    baseUrl: "/verification/", // 本项目地址前缀
    baseApiUrl: "/verificationServer/", // 后台接口请求地址前缀
    // baseApiUrl: "/demo_fw_server/", // 后台接口请求地址前缀
    baseFileUrl: "", // 文件地址前缀
    timeout: 600000, // 接口请求超时时间
    mainPage: "baseUser", // 首次进入页面地址
    loginType: "web", // 登录类型
    sysName: "防伪平台", // 系统名称
    fixed_baseApiIpHost_enabled: false, // 后台接口请求地址ip端口 是否固定
    fixed_baseApiIpHost: "127.0.0.1:5000", // 后台接口请求地址前缀
    collect_file: "/collect_file/", // 文件地址前缀
    search_background_img: "search_background_img" // 搜索页面文件类型
};



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 24
// module chunks = 15